import { ReactNode } from "react"

export interface WaitForResProps<RES extends any> {
  res: RES
  loading: boolean
  error: string | null
  children: (res: NonNullable<RES>) => ReactNode
}

export const WaitForRes = <RES extends any>({ children, res, error, loading }: WaitForResProps<RES>) => {
  if (loading)
    return <p className="flex items-center justify-center p-4">Loading...</p>
  if (error)
    return <p className="text-red-600 p-4">{error}</p>
  if (!res)
    return <p className="p-4 text-amber-600">No data available</p>
  return children(res)
}
